module.exports = __webpack_public_path__ + "static/media/small_logo.3f01fed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/small_logo.png
// module id = 6743
// module chunks = 0